import React, { memo, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { isEmpty } from 'lodash'

import styles from './CartItem.module.scss'
import { ReactComponent as CloseIcon } from '../assets/icons/Close-Icon.svg'

const CartItem = ({
  id,
  name,
  modifiers,
  price,
  quantity,
  onRemove,
  onSelect,
  index, // id of item when selected or being removed
  isDiscount,
  isSpecialtyItem,
  onSpecialtyItemClick,
  className,
  remoteOrderTotalLoading = false,
  numberOfLines = null,
  realCartItem = false,
}) => {
  const classNames = cn(styles.cartItem, className)
  let modifiersElement = null
  const mods = modifiers.split(', ').join('\n')

  const cartItemRef = useRef()

  if (!isEmpty(modifiers)) {
    modifiersElement = <span className={styles.modifiers}>{mods}</span>
  }

  const handleOnRemove = (event, id) => {
    if (remoteOrderTotalLoading) return
    event.preventDefault()
    event.stopPropagation()

    onRemove(id)
  }

  const handleItemClick = (event) => {
    if (isSpecialtyItem) {
      onSpecialtyItemClick()
    }
  }

  useEffect(() => {
    if (cartItemRef.current) {
      cartItemRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }, [])

  const ItemDisplay = () => {
    if (realCartItem) {
      return (
        <div className={styles.realItemContainer}>
          <div className={cn([styles.itemName])}>{name}</div>
          <div className={cn([styles.itemPrice])}>{price}</div>
        </div>
      )
    }

    return (
      <span
        className={cn([styles.name, isDiscount && styles.isDiscount, numberOfLines && styles.multiLine])}
        style={{ '--line-clamp': numberOfLines }}
      >
        {name} {price}
      </span>
    )
  }

  return (
    <div className={classNames} onClick={() => onSelect(index)} ref={cartItemRef}>
      {!isDiscount && !isSpecialtyItem && (
        <div className={styles.column}>
          <span className={styles.quantity}>{quantity}</span>
        </div>
      )}
      <div onClick={handleItemClick} className={cn(styles.column, styles.nameColumn)}>
        <ItemDisplay />
        {modifiersElement}
      </div>
      <div className={styles.column}>
        <CloseIcon className={styles.closeIcon} onClick={(event) => handleOnRemove(event, index)} />
      </div>
    </div>
  )
}

CartItem.defaultProps = {
  id: '',
  name: '',
  modifiers: '',
  price: '',
  quantity: 1,
  color: '',
  onRemove: () => {},
  onSelect: () => {},
}

CartItem.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  modifiers: PropTypes.string,
  price: PropTypes.string,
  quantity: PropTypes.number,
  color: PropTypes.string,
  onRemove: PropTypes.func,
  className: PropTypes.string,
}

export default memo(CartItem)
